import React from "react"
import "./frames.css"

const Sigma34 = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">
        Modelo Sigma 34: Máxima Comodidad a un Coste Asequible
      </h1>

      <h2 className="frames-subtitle">
        Diseñado para el Mercado Internacional
      </h2>
      <p className="frames-text">
        El modelo SIGMA 34 no solo se ha consolidado como uno de los más
        vendidos a nivel internacional, sino que también ha encontrado una
        acogida especial en los países asiáticos. Su diseño estratégico maximiza
        la comodidad del paciente, manteniendo simultáneamente un enfoque en la
        asequibilidad y versatilidad en la instalación.
      </p>

      <h2 className="frames-subtitle">Versatilidad y Movilidad</h2>
      <p className="frames-text">
        Una de las principales ventajas del SIGMA 34 es su facilidad de
        instalación y traslado. Equipado con ruedas giratorias, este modelo se
        desplaza sin esfuerzo por esquinas y pasillos, permitiendo su acceso sin
        problemas a través de puertas estándar. Estas características lo hacen
        ideal para entornos donde la movilidad y la adaptabilidad son cruciales.
      </p>

      <h2 className="frames-subtitle">
        Confort y Diseño Pensado en el Paciente
      </h2>
      <p className="frames-text">
        El cilindro acrílico de 34 pulgadas (86 cm) es una característica
        distintiva del SIGMA 34. Esta característica, combinada con la capacidad
        de inclinar a los pacientes hasta 25 grados y la transparencia total del
        material, minimiza considerablemente cualquier sensación de
        confinamiento que el paciente pueda experimentar. El resultado es una
        experiencia más relajante y confortable durante el tratamiento
        hiperbárico.
      </p>

      <h2 className="frames-subtitle">
        Inversión Inteligente para Centros Hiperbáricos
      </h2>
      <p className="frames-text">
        El SIGMA 34 no solo representa una inversión inicial baja, sino que
        también tiene requisitos mínimos en términos de espacio, personal e
        instalaciones. Ya sea que se esté considerando la apertura de una nueva
        Unidad Hiperbárica o se busque aumentar la capacidad de una unidad
        existente, este modelo es una opción inigualable en cuanto a
        coste-efectividad y rendimiento.
      </p>
    </div>
  )
}

export default Sigma34
